import Typography from '~/components/Typography';
import VersatileLink from '~/components/VersatileLink';

import type { NavigationLink, WebThemeV2 } from '~/interfaces/publication';

interface Props {
  link: NavigationLink;
  theme: WebThemeV2;
}

const SingleLink = ({ link, theme }: Props) => {
  const isExternalLink = link.external_link;
  const href = isExternalLink ? link.href : `/c/${link.href}`;

  return (
    <VersatileLink
      href={href}
      isExternalLink={isExternalLink}
      className="transition:all rounded-wt px-2 py-2 hover:bg-black/5"
    >
      <Typography
        as="span"
        color={theme.navbar_text_color}
        fontFamilyv2={theme.navbar_font_family}
        className="whitespace-nowrap text-xs sm:block"
      >
        {link.cta_text}
      </Typography>
    </VersatileLink>
  );
};

export default SingleLink;
